import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DatabaseUtil from './Util/DatabaseUtil';
import SideBar from './Components/SideBar';
import { useTranslation } from 'react-i18next';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

const DashVideoDetail = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const [videoDetails, setVideoDetails] = useState(null);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);
  let roleString= '';

    useEffect(() => {
        const fetchVideoDetails = async () => {
            try {
                const details = await DatabaseUtil.getVideoDetailsById(id);
                setVideoDetails(details);
            } catch (error) {
                console.error('Failed to fetch video details:', error);
                setError('Failed to load video details.');
            } finally {
                setLoading(false);
            }
        };

        fetchVideoDetails();
    }, [id]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    const handleThumbnailClick = () => {
        setIsVideoPlaying(true); // Show video player
    };

//Refactor evenutally
    if(videoDetails.role === 'Caregiver')
{
    roleString = t('caregiver');
}
else if (videoDetails.role === 'Teacher')
{
    roleString =t('teacher');
}
else if(videoDetails.role === 'Classmate')
{
    roleString = t('classmate');
}
else
{
    roleString = t('student');
}

const getTopicLabel = (categoryId) => {
  const topics = {
    1: "Linguistic competence and interaction",
    2: "Cultural awareness",
    3: "Cultural competence and understanding of the latin perspective",
    4: "Cultural competence and understanding of the american perspective",
    5: "Disability knowledge and awareness",
    6: "Representation",
    7: "Inclusive communication",
    8: "Empathy and sensitivity training",
    9: "Social integration skills",
    10: "Parent and caregiver involvement",
    11: "Cultural representation in curriculum",
    12: "Anti-bias education",
    13: "Legal and ethical understanding",
    14: "Peer support and mentoring",
    15: "Professional development and resources for educators"
  };
  return topics[categoryId] || `Topic ${categoryId}`;
};

return (
    <>
        <SideBar />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
            <h2 style={{ margin: 0, marginBottom: '10px', color: 'var(--primary-color)' }}>{videoDetails.title}</h2>
            <p style={{color: 'var(--primary-color)' }}>ID: <strong>{videoDetails.id}</strong></p>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                {/* Thumbnail or Video */}
                {isVideoPlaying ? (
                    <video 
                        style={{ 
                            width: '300px', 
                            height: 'auto', 
                            borderRadius: '10px', 
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            /*minHeight: '800px'*/
                        }} 
                        controls 
                        autoPlay
                    >
                        <source src={videoDetails.url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <div style={{ position: 'relative', cursor: 'pointer' }} onClick={handleThumbnailClick}>
                        <img 
                            style={{ 
                                width: '300px', 
                                height: 'auto', 
                                borderRadius: '10px', 
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' 
                            }} 
                            src={videoDetails.thumbnail} 
                            alt={`${videoDetails.title} Thumbnail`} 
                        />
                        <PlayCircleIcon
                            style={{ 
                                position: 'absolute', 
                                top: '50%', 
                                left: '50%', 
                                transform: 'translate(-50%, -50%)', 
                                fontSize: '200px', 
                                color: 'var(--primary-white-color)',
                                opacity: 0.9
                            }} 
                        />
                    </div>
                    
                )}

            {/* Video Details */}
            <div 
                style={{ 
                    backgroundColor:'var(--primary-color)', 
                    color: 'var(--primary-white-color)',
                    padding: '20px', 
                    borderRadius: '10px', 
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
                    textAlign: 'left',
                    maxWidth: '1000px'
                }}
            >
                   

        

                <p style={{ margin: '5px 0' }}>{t('role')}: <strong>{roleString}</strong></p>
                <p style={{ margin: '5px 0' }}>{t('topic')}: <strong>{getTopicLabel(videoDetails.category)}</strong></p>
                <div 
                    style={{
                        borderTop: '5px solid #FFFFFF',
                        borderRadius: '5px',   
                        margin: '5px 0',
                    }}
                ></div>
                <p style={{ margin: '5px 0' }}>{t('duration')}: <strong>{videoDetails.duration}</strong></p>
                <p style={{ margin: '5px 0' }}>{t('language')}: <strong>{videoDetails.language}</strong></p>
                <div 
                    style={{
                        borderTop: '5px solid #FFFFFF',
                        borderRadius: '5px',   
                        margin: '5px 0',
                    }}
                ></div>
                <p style={{ margin: '5px 0' }}>{t('likes')}: <strong>{videoDetails.totalLikes}</strong></p>
                <p style={{ margin: '5px 0' }}>{t('comments')}: <strong>{videoDetails.totalComments}</strong></p>
                <p style={{ margin: '5px 0' }}>{t('intComments')}: <strong>{videoDetails.totalGoodComments}</strong></p>
                <p style={{ margin: '5px 0' }}>{t('nIntComments')}: <strong>{videoDetails.totalBadComments}</strong></p>

                <div 
                    style={{
                        borderTop: '5px solid #FFFFFF',
                        borderRadius: '5px',   
                        margin: '5px 0',
                    }}
                ></div>
                <p style={{ margin: '5px 0' }}>{t('viewers')}: <strong>{videoDetails.totalViews}</strong></p>
                <p style={{ margin: '5px 0' }}>{t('avgWatchtime')}: <strong>{videoDetails.averageWatchtime.toFixed(2)}%</strong></p>
                <p style={{ margin: '5px 0' }}>{t('fullWatchRate')}: <strong>{videoDetails.fullWatchRate.toFixed(2)}%</strong></p>
                
                <div 
                    style={{
                        borderTop: '5px solid #FFFFFF',
                        borderRadius: '5px',   
                        margin: '10px 0',
                    }}
                ></div>

                    {videoDetails.commentDetails.map((comment, index) => (
                        <div key={index}>
                            <p style={{ margin: '5px 0' }}>
                                <strong>{comment.username}:</strong> {comment.text}
                            </p>
                        </div>
                    ))}
            </div>
            

        </div>
        
        </div>
    </>
);

};

export default DashVideoDetail;